import ExaminationResultItem, { ExaminationResultItemProps } from './ExaminationResultItem';
export default ExaminationResultItem;
export type { ExaminationResultItemProps };
